import Manage from '../views/Advertisement/Manage.vue';
import PutIn from '../views/Advertisement/PutIn.vue';
import Position from '../views/Advertisement/Position.vue';

let Advertisement = [
  {
    path: 'Manage',
    name: '物料管理',
    component: Manage
  },
  {
    path: 'PutIn',
    name: '投放管理',
    component: PutIn
  },
  {
    path: 'Position',
    name: '广告位管理',
    component: Position
  }
];
export default Advertisement;
